export const loader = `<div class="loader-spinner">
    <div></div>
    <div></div>
</div>

<div class="loader-bouncer">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
</div>

<div class="loader-flipping-squares">
    <div></div>
    <div></div>
</div>`